import en from './en_US.js';
import ar from './ar_EG.js';

export default { en, ar };